import Btn from './shared/Btn';

/**
 * @param {{ conflict: object|null, onReload: () => void, onForce: () => void }} props
 */
export default function ConflictBanner({ conflict, onReload, onForce }) {
  if (!conflict) return null;
  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 12,
      padding: '10px 16px', margin: '12px 24px',
      background: 'var(--ab-pending-soft)',
      borderLeft: '3px solid var(--ab-pending)',
      borderRadius: 'var(--ab-radius-sm)',
    }}>
      <div style={{ flex: 1, fontSize: 13 }}>
        ⚠ This claim was updated in another session.
      </div>
      <Btn kind="secondary" size="sm" onClick={onReload}>Reload</Btn>
      <Btn kind="primary" size="sm" onClick={onForce}>Force overwrite</Btn>
    </div>
  );
}
